import { AppState } from '../root-reducer';

export const selectPurchasedListings = (state: AppState) => state.purchasesDomain.purchasedListings;
